/**
 * Created by jv on 04/01/2017.
 */
const config = require("Sources/config/config");

var utils = {};
var queryParams;
var performanceStart;
var performanceEnd;

(function(Utils)
{
  Utils.emptyStringChar = "-";

  Utils.UUID = function()
  {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = Math.random()*16|0, v = c === "x" ? r : (r&0x3|0x8);
      return v.toString(16);
    });
  };

  Utils.generateUIDShort = function()
  {
    return ("0000" + (Math.random()*Math.pow(36,4) << 0).toString(36)).slice(-4);
  };

  Utils.redirect = function(link)
  {
    window.location.href = link;
  };

  Utils.refreshPage = function()
  {
    window.location.reload(false);
  };

  // %note: might be better to use https://www.npmjs.com/package/lodash for most of these utility functions
  Utils.isUndefined = function(obj)
  {
    return typeof obj === "undefined";
  };

  Utils.isDefined = function(obj)
  {
    return !Utils.isUndefined(obj);
  };

  Utils.isNull = function(obj)
  {
    return typeof obj === "undefined" || obj === null;
  };

  Utils.isNotNull = function(obj)
  {
    return !Utils.isNull(obj);
  };

  Utils.isNullOrEmpty = function(str)
  {
    return Utils.isNull(str) || str === "";
  };

  Utils.isString = function(value)
  {
    return typeof value === "string";
  };

  Utils.isBoolean = function(value)
  {
    return value === true || value === false;
  };

  Utils.isNumber = function(value)
  {
    return Utils.isNotNull(value) && typeof value === "number";
  };

  Utils.isArray = function(obj)
  {
    return Utils.isNotNull(obj) && Array.isArray(obj);
  };

  Utils.isObject = function(obj)
  {
    return Utils.isNotNull(obj) && typeof obj === "object";
  };

  Utils.isMomentObject = function(obj)
  {
    return Utils.isObject(obj) && obj.hasOwnProperty("_isAMomentObject") && obj._isAMomentObject === true;
  };

  Utils.isFunction = function(obj)
  {
    return typeof obj === "function";
  };

  Utils.isValidEmail = function(email)
  {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  Utils.isValidBtwNumber = function(btw)
  {
    if (!btw)
      return false;

    const re = /^((BE)(0\d{9})|(NL)(\d{9}(B\d{2}|BO2)))$/;
    const cleanedBtw = btw.replaceAll(" ", "").replaceAll(".", "");
    return re.test(cleanedBtw);
  }

  Utils.stringToInt = function(value)
  {
    if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value))
    {
      return Number(value);
    }

    return NaN;
  };

  Utils.stringToBoolean = function(str)
  {
    return str === "true";
  }

  Utils.stringifyJSON = function(obj, replacer, space)
  {
    return JSON.stringify(obj, replacer, space);
  };

  Utils.parseJSON = function(str, safe)
  {
    if(safe)
    {
      try
      {
        var objValue = JSON.parse(str);
        return objValue;
      }
      catch(e)
      {
        return str;
      }
    }
    else
    {
      return JSON.parse(str);
    }
  };

  Utils.roundNumber = function(number, decimals)
  {
    if(Utils.isNumber(number))
    {
      var rounder = Math.pow(10, decimals);
      return Math.round(number * rounder) / rounder;
    }

    return NaN;
  };

  Utils.getRandomIntInclusive = function(min, max)
  {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  Utils.getMinSafeInt = function()
  {
    return Number.MIN_SAFE_INTEGER;
  };

  Utils.getMaxSafeInt = function()
  {
    return Number.MAX_SAFE_INTEGER;
  };

  Utils.removeWhitespace = function(str)
  {
    if(Utils.isNotNull(str) && Utils.isString(str))
    {
      return str.replace(/ /g,"");;
    }

    return str;
  }

  Utils.devLog = function()
  {
    if(__DEVELOPMENT__ && Utils.isNotNull(console))
    {
      console.log.apply(console, arguments);
    }
  };

  Utils.getQueryParam = function(name)
  {
    return queryParams[name];
  };

  Utils.getPathSection = function(index)
  {
    var path = window.location.pathname;
    var pathSections = path.split("/");

    for(var i = 0; i < pathSections.length; i++)
    {
      var pathSection = pathSections[i];

      if(Utils.isNullOrEmpty(pathSection))
      {
        index++;
        continue;
      }

      if((i + 1) === index)
      {
        return pathSection;
      }
    }

    return null;
  };

  Utils.getUrlHash = function()
  {
    return window.location.hash;
  }

  Utils.readCookie = function(name)
  {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");

    for(var i = 0; i < ca.length; i++)
    {
      var c = ca[i];
      while(c.charAt(0)===" ") c = c.substring(1, c.length);
      if(c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
  };

  Utils.getServiceUrl = function(command)
  {
    return config.serviceBaseURL + config.serviceVersion + "/" + command;
  };

  Utils.format = function(format)
  {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function(match, number)
    {
      return utils.isDefined(args[number]) ? args[number] : match;
    });
  };

  Utils.getValueFromSplit = function(str, index, splitStr)
  {
    var result;

    if(!utils.isNullOrEmpty(str))
    {
      var split = str.split(splitStr);

      if(split.length >= (index + 1))
      {
        result = split[index];
      }
    }

    return result;
  };

  Utils.performance = function()
  {
    var result = null;

    if(utils.isNotNull(performanceStart))
    {
      performanceEnd = performance.now();
      result = performanceEnd - performanceStart;

      performanceStart = null;
      performanceEnd = null;
    }
    else
    {
      performanceStart = performance.now();
    }

    return result;
  }

  Utils.getColorClassForStatus = function(status)
  {
    switch(status)
    {
      case "payed":
      case "valid":
      case "complete":
        return "text-green";
      case "awaiting_payment":
      case "expired":
        return "text-red-warm";
      default:
        return "";
    }
  };

  Utils.getReadableLanguageForKey = function(key)
  {
    switch(key.toUpperCase())
    {
      case "NL":
        return "globals.languages.dutch";
      default:
        return key;
    }
  };

  Utils.getReadableCountryForKey = function(key)
  {
    switch(key.toUpperCase())
    {
      case "BE":
        return "globals.countries.belgium";
      case "NL":
        return "globals.countries.netherlands";
      default:
        return key;
    }
  };

  Utils.getReadableLocaleForKey = function(key)
  {
    switch(key.toUpperCase())
    {
      case "NL_BE":
        return "globals.locales.nl_BE";
      case "NL_NL":
        return "globals.locals.nl_NL";
      default:
        return key;
    }
  };

  return Utils;
}(utils));

// Load query parameters once
(window.onpopstate = function () {
    var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = window.location.search.substring(1);

    queryParams = {};
    while (match = search.exec(query))
    {
      var name = decode(match[1]);
      var value = decode(match[2]);

      if(queryParams.hasOwnProperty(name))
      {
        if(!utils.isArray(queryParams[name]))
        {
          // Make it an array
          queryParams[name] = [ queryParams[name] ];
        }

        queryParams[name].push(value);
      }
      else
      {
        queryParams[name] = value;
      }
    }
})();

module.exports = utils;



// WEBPACK FOOTER //
// ./app/js/utils/utils.js